package com.xtream.composeapp.data


import androidx.navigation3.runtime.NavKey
import com.xtream.core_model.dto.MovieSubtitle
import com.xtream.data_kmp.db.tables.StreamType
import com.xtream.data_kmp.dto.LiveCategory
import com.xtream.data_kmp.dto.PlayerPlaylistItem
import kotlinx.serialization.Serializable

@Serializable
sealed class Screen(val id:Int?=null) : NavKey {


    //for main navbar
    @Serializable
    object Home : Screen()
    @Serializable
    object Browse : Screen()

    @Serializable
    object LiveTv : Screen()

    @Serializable
    object Movies : Screen()

    @Serializable
    object TvShows : Screen()
    @Serializable
    object Playlists : Screen()
    @Serializable
    object Settings : Screen()





    //for root nav graph
    @Serializable
    data class Loading(val skipUserRefresh: Boolean = false, val forceRefreshData: Boolean = false, ) : Screen()
    @Serializable
    object NavBar : Screen()

    @Serializable
    data class MenuLiveStreamPlayer(private val streamId: Int?, val categoryId: Int?, val title: String?) :
        Screen(streamId){
    }
    @Serializable
    data class LiveStreamPlayer(private val streamId: Int?, val categoryId: Int?, val title: String?) :
        Screen(streamId)
    @Serializable
    data class VideoPlayer(private val streamId: Int?,
                           val categoryId: Int?,
                           val title: String?,

                           val backdropPath:String?,
                           val infos: List<String>? = null,
                           val url:String?,
                           val progress:Long?=0,
                           val subtitles: List<MovieSubtitle.Subtitle?>? = null
    ) :
        Screen(streamId)

    @Serializable
    data class TvShowVideoPlayer(private val streamId: Int?,
                                 val categoryId: Int?,
                                 val title: String?,
                                 val backdropPath:String?,
                                 val infos: List<String>? = null,
                                 val url:String?,
                                 val progress:Long?=0,
                                 val subtitles: List<MovieSubtitle.Subtitle>? = null

    ) :
        Screen(streamId)

    @Serializable
    data class LiveTvGrid(val categoryId: Int?, val title: String?) : Screen()


    @Serializable
    data class MovieDetail(private val movieId: Int?) : Screen(movieId)

    @Serializable
    data class MoviesGrid(val categoryId: Int?, val title: String?) : Screen()


    @Serializable
    data class TvShowDetail(val tvShowId: Int?) : Screen(tvShowId)

    @Serializable
    data class SeriesGrid(val categoryId: Int?, val title: String?) : Screen()

    @Serializable
    object AccountInfo : Screen()
    @Serializable
    data class Search(val initialPage: Int = 0) : Screen()
    object Discover : Screen()

    @Serializable
    data class Trailer(val url: String?) : Screen()


    @Serializable
    data class ManagePlaylist(val playList: PlayerPlaylistItem) : Screen()

    @Serializable
    object ChoseTvCategory : Screen()

    @Serializable
    data class ManageTvChannels(val liveCategory: LiveCategory) : Screen()

    data class ManageCategories(val type: StreamType) : Screen()

}